class Service {
  constructor(data) {
    this.$originalData = data;
    const {
      name,
      price,
      allow_custom_pickup_locations,
      allow_custom_dropoff_locations,
      hidden,
      pay_ratio,
      send_instructor_change_notification,
      send_last_minute_availability_alert,
      disable_notifications_after_completion_of_curriculum,
      auto_verify_on_purchase,
    } = data;
    this.$name = name;
    this.$price = price;
    this.$allow_custom_pickup_locations = allow_custom_pickup_locations;
    this.$allow_custom_dropoff_locations = allow_custom_dropoff_locations;
    this.$hidden = hidden || false;
    this.$pay_ratio = pay_ratio || 1;
    this.$send_instructor_change_notification =
      send_instructor_change_notification;
    this.$send_last_minute_availability_alert =
      send_last_minute_availability_alert;
    this.$disable_notifications_after_completion_of_curriculum =
      disable_notifications_after_completion_of_curriculum;
    this.$auto_verify_on_purchase = auto_verify_on_purchase || false;
  }

  /**
   * @returns {string}
   */
  name() {
    return this.$name;
  }

  /**
   * @returns {number}
   */
  price() {
    return this.$price;
  }

  /**
   * @returns {boolean}
   */
  allowCustomPickupLocations() {
    return this.$allow_custom_pickup_locations;
  }

  /**
   * @returns {boolean}
   */
  allowCustomDropOffLocations() {
    return this.$allow_custom_dropoff_locations;
  }

  /**
   * @returns {boolean}
   */
  hidden() {
    return this.$hidden;
  }

  /**
   * @returns {number}
   */
  payRatio() {
    return this.$pay_ratio;
  }

  /**
   * @returns {boolean}
   */
  sendInstructorChangeNotification() {
    return this.$send_instructor_change_notification;
  }

  /**
   * @returns {boolean}
   */
  sendLastMinuteAvailabilityAlert() {
    return this.$send_last_minute_availability_alert;
  }
}

export { Service };

